import moment from "moment-timezone";

export const formatLocalDateTime = (dateValue, format, includeTimeZone = false) => {
  if (!dateValue) {
    return "—";
  }

  const hasExplicitTimeZone =
    typeof dateValue === "string" && /(?:Z|[+-]\d{2}:?\d{2})$/i.test(dateValue.trim());
  const parsed = hasExplicitTimeZone
    ? moment.parseZone(dateValue)
    : typeof dateValue === "string"
      ? moment.tz(dateValue, "Asia/Kolkata")
      : moment(dateValue);
  if (!parsed.isValid()) {
    return "—";
  }

  const localDate = parsed.local();
  const formattedDate = localDate.format(format);
  if (!includeTimeZone) {
    return formattedDate;
  }

  const localTimeZone = moment.tz.guess();
  const zoneAbbreviations = {
    "Asia/Dhaka": "BDT",
    "Asia/Kolkata": "IST",
  };
  const abbreviation = moment
    .tz(localDate.toDate(), localTimeZone)
    .zoneAbbr();
  const timeZone =
    zoneAbbreviations[localTimeZone] ||
    (/^[+-]\d{2}/.test(abbreviation)
      ? new Intl.DateTimeFormat("en-US", {
          timeZone: localTimeZone,
          timeZoneName: "long",
        })
          .formatToParts(localDate.toDate())
          .find((part) => part.type === "timeZoneName")?.value
      : abbreviation);

  return timeZone ? `${formattedDate} ${timeZone}` : formattedDate;
};